export enum EIndicadoresDashboard {
  regrasDashbaordIndicadores = "regrasDashbaordIndicadores"
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type IFilterIndicadores<T = Record<string, string>> =
  | Record<string, any>
  | T;

export interface IViewContextUserPreferences {
  view: string;
  context: string;
}

export enum EIndicadoresUserPreferences {
  view = "indicadores",
  context = "filtros"
}

export enum EUserPreferencesName {
  Preferencias = "Preferencias"
}

export interface IDataPreference<T = string | number | boolean> {
  fieldName: string;
  fieldData: T;
  displayName: string;
  id: number;
}

export interface IFiltrosPainelDeVendas {
  companies: string[] | string;
  sourceData: number;
  shortcut: number;
}

export interface IFiltrosPagarEReceber {
  companies: string[] | string;
}

export interface IFiltrosConciliacao {
  empresas: string[] | string;
  data: string | string[];
}

export interface IFiltrosNotasFiscais {
  empresas: string[] | string;
  data: string | string[];
}

export interface IFiltrosReceitasVencidas {
  companies: string[] | string;
}

export interface IFiltrosFluxoDeCaixaVariation {
  panelFluxoFilter: {
    contas?: string[] | string;
    Status?: number;
    PlanosOrcamentarios?: string[];
    APartirUltimoDiaConciliado?: false;
    ExibirParcelasNaoAprovadas?: false;
    OcultarTransferencias?: false;
    ValoresNosDiasOriginais?: false;
    OcultarDinheiroDeCaixasAbertos?: false;
    AdicionarUmDiaNoVencimentoDeBoletosAReceber?: false;
    OcultarTitulosVencidos?: false;
  };
}

export interface IFiltrosFluxoDeCaixa extends IFiltrosFluxoDeCaixaVariation {
  contas?: string[] | string;
  Status?: number | string;
  PlanosOrcamentarios?: string[];
  APartirUltimoDiaConciliado?: false;
  ExibirParcelasNaoAprovadas?: false;
  OcultarTransferencias?: false;
  ValoresNosDiasOriginais?: false;
  OcultarDinheiroDeCaixasAbertos?: false;
  AdicionarUmDiaNoVencimentoDeBoletosAReceber?: false;
  OcultarTitulosVencidos?: false;
}

export interface IFiltrosDRE {
  empresas: string[] | string;
  centrosDeCusto: string[] | string;
  data: string | string[];
}

export interface IFiltrosDRE {
  empresas: string[] | string;
  centrosDeCusto: string[] | string;
  data: string | string[];
}

export interface IDesempenhoVendasPanelVariation {
  panelDesempenhoVendasFilter?: {
    empresas: string[] | string;
  };
}

export interface IFiltrosDesempenhoVendasPanel
  extends IDesempenhoVendasPanelVariation {
  empresas?: string[] | string;
}

export interface IFiltrosFechamentoDeCaixaVariation {
  localFilter?: {
    empresas: string[] | string;
  };
}

export interface IFiltrosFechamentoDeCaixa
  extends IFiltrosFechamentoDeCaixaVariation {
  empresas: string[] | string;
}

export interface IFiltrosVendasCanceladas {
  data: string | string[];
}

export interface ISalvarFiltroParams {
  companies?: string[];
  sourceData?: number;
  empresas?: string[] | string;
  data?: string[] | string;
  centrosDeCusto?: string[] | string;
  panelFluxoFilter?: {
    contas: string | string[];
    Status: string | number;
    PlanosOrcamentarios: string | string[];
    APartirUltimoDiaConciliado: boolean;
    ExibirParcelasNaoAprovadas: boolean;
    OcultarTransferencias: boolean;
    ValoresNosDiasOriginais: boolean;
    OcultarDinheiroDeCaixasAbertos: boolean;
    AdicionarUmDiaNoVencimentoDeBoletosAReceber: boolean;
    OcultarTitulosVencidos: boolean;
  };
  FieldName?: string;
  FieldData?: string;
  DisplayName?: string;
  vendasShortcut?: number;
  fluxoShortcut?: number;
  shortcut?: number;
  id?: number;
}

export interface IPreferencesUser {
  name: string;
  contexts: IViewContextUserPreferences[];
  preferences: IDataPreference[];
  _id?: string;
  isDefault?: boolean;
}

export enum EDisplayName {
  vendasPanel = "VendasPanel",
  exempleCard = "ExempleCard",
  cardConciliacao = "CardConciliacao",
  cardNotasFiscais = "CardNotasFiscais",
  cardReceitasVencidas = "CardReceitasVencidas",
  fluxoCaixaPainel = "FluxoCaixaPainel",
  dREPanel = "DREPanel",
  desempenhoVendas = "DesempenhoVendas",
  cardFechamentoCaixa = "CardFechamentoCaixa",
  cardVendasCanceladas = "CardVendasCanceladas"
}

export enum EFieldsName {
  empresas = "Empresas",
  origemDosDados = "OrigemDosDados",
  periodoInicio = "PeriodoInicio",
  periodoFim = "PeriodoFim",
  contas = "Contas",
  centroDeCusto = "CentroDeCusto",
  vendasShortcut = "vendasShortcut",
  vendasShortcutPeriodoInicio = "vendasShortcutPeriodoInicio",
  vendasShortcutPeriodoFim = "vendasShortcutPeriodoFim",
  fluxoShortcut = "fluxoShortcut",
  fluxoShortcutPeriodoInicio = "fluxoShortcutPeriodoInicio",
  fluxoShortcutPeriodoFim = "fluxoShortcutPeriodoFim",
  fluxoAPartirUltimoDiaConciliado = "fluxoAPartirUltimoDiaConciliado",
  fluxoAdicionarUmDiaNoVencimentoDeBoletosAReceber = "fluxoAdicionarUmDiaNoVencimentoDeBoletosAReceber",
  fluxoAExibirParcelasNaoAprovadas = "fluxoAExibirParcelasNaoAprovadas",
  fluxoOcultarDinheiroDeCaixasAbertos = "fluxoOcultarDinheiroDeCaixasAbertos",
  fluxoOcultarTitulosVencidos = "fluxoOcultarTitulosVencidos",
  fluxoOcultarTransferencias = "fluxoOcultarTransferencias",
  fluxoPlanosOrcamentarios = "fluxoPlanosOrcamentarios",
  fluxoStatus = "fluxoStatus",
  fluxoValoresNosDiasOriginais = "fluxoValoresNosDiasOriginais",
  desempenhoDeVendasShortcut = "desempenhoDeVendasShortcut",
  desempenhoDeVendasPeriodoInicio = "desempenhoDeVendasPeriodoInicio",
  desempenhoDeVendasPeriodoFim = "desempenhoDeVendasPeriodoFim",
  vendasCanceladasPeriodoInicio = "vendasCanceladasPeriodoInicio",
  vendasCanceladasPeriodoFim = "vendasCanceladasPeriodoFim"
}
